import classNames from 'classnames';
import { Icon, IconProps } from '@components/icon';
import './DropdownIconWrapper.scss';

export type DropdownIconWrapperProps = Omit<IconProps, 'size'>;

/**
 * DropdownIconWrapper Component
 * @param className - Additional class to add to the icon
 * @param name - Name of icon to be displayed
 * @constructor
 */
export const DropdownIconWrapper: React.FC<DropdownIconWrapperProps> = ({ className, name }) => (
  <div className={classNames('vds-dropdown-icon-wrapper', className)}>
    <Icon name={name} />
  </div>
);
